module.exports = __webpack_public_path__ + "img/releaseWorkflow_01.34c52314.png";